export default __webpack_public_path__ + "static/media/cloud3.8c362203.png";